module.exports = __webpack_public_path__ + "img/contentburger-logo-colored.d92921be.png";